import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { TextField, Button, Box, Typography, Container, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAuth } from '../context/AuthContext';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [condominios, setCondominios] = useState([]);
  const [empresaId, setEmpresaId] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await api.post('/auth/login', {
        email,
        senha,
        ...(empresaId ? { empresa_id: empresaId } : {}),
      });
      login(response.data.token, response.data.user);
      navigate('/acessos');
    } catch (err) {
      console.error('Erro de login:', err);
      if (err.response?.status === 409 && err.response.data?.selecionarCondominio) {
        const options = err.response.data.condominios || [];
        setCondominios(options);
        if (options.length === 1) setEmpresaId(options[0].empresa_id);
        setError('Selecione o condomínio para continuar.');
        return;
      }
      setError(err.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.');
    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          component="div"
          variant="h3"
          sx={{
            color: 'primary.main',
            fontWeight: 900,
            lineHeight: 1,
            letterSpacing: '-0.08em'
          }}
        >
          coNDu
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Endereco de Email"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="senha"
            label="Senha"
            type="password"
            id="senha"
            autoComplete="current-password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
          {condominios.length > 0 && (
            <FormControl fullWidth margin="normal" required>
              <InputLabel id="condominio-login-label">Condomínio</InputLabel>
              <Select
                labelId="condominio-login-label"
                value={empresaId}
                label="Condomínio"
                onChange={(e) => setEmpresaId(e.target.value)}
              >
                {condominios.map((condominio) => (
                  <MenuItem key={condominio.empresa_id} value={condominio.empresa_id}>
                    {condominio.empresa_nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Entrar
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default LoginPage;
